import { SpreadsheetValue } from "@common/helpers/spreadsheet";
import { initContract } from "@ts-rest/core";
import { z } from "zod";

export type SpreadsheetRow = Record<string, SpreadsheetValue>;
export type Spreadsheet = SpreadsheetRow[];

const c = initContract();

const accessParams = z.object({
    financialDocumentId: z.coerce.number().optional(),
});
export type SpreadsheetAccessParams = z.infer<typeof accessParams>;

export const spreadsheetContract = c.router(
    {
        getSpreadsheet: {
            path: "/:id",
            method: "GET",
            query: accessParams,
            responses: {
                200: c.type<{ spreadsheet: Spreadsheet }>(),
            },
        },
        updateSpreadsheet: {
            path: "/:id/updates",
            method: "POST",
            query: accessParams,
            body: z.object({
                updates: z.array(
                    z.object({
                        row: z.number(),
                        column: z.string(),
                        value: z.string().or(z.number()).nullable(),
                    }),
                ),
            }),
            responses: {
                200: c.noBody(),
            },
        },
    },
    {
        pathPrefix: "/spreadsheet",
    },
);
